import { useEffect } from 'react';

import Typography from 'components/shared/Typography/Typography';
import PaymentProgramBody from 'components/practice/Settings/components/HealthcareProgram/components/PaymentProgramTab/components/PaymentProgramBody';
import { usePaymentProgramDraft } from 'components/practice/Settings/components/HealthcareProgram/components/PaymentProgramTab/lib/usePaymentProgramDraft';
import PaymentProgramSkeleton from 'components/practice/Settings/components/HealthcareProgram/components/PaymentProgramTab/components/PaymentProgramSkeleton/PaymentProgramSkeleton';

const OnboardingPaymentProgram = ({
  addFooterActions,
  mutateOrchestratorData,
  orchestratorLoading,
  orchestratorData
}) => {
  const {
    data,
    isLoading,
    isError,
    draft,
    dispatch,
    activePhaseField,
    setActivePhaseField,
    isDirty,
    isSaving,
    saveAsync
  } = usePaymentProgramDraft({
    practiceId: orchestratorData?.practiceId,
    enabled: !!orchestratorData?.practiceId
  });

  useEffect(() => {
    addFooterActions([
      {
        text: 'Continue',
        onClick: async () => {
          if (isError) return;
          if (isDirty) {
            try {
              const ok = await saveAsync();
              if (!ok) return;
            } catch {
              return;
            }
          }
          mutateOrchestratorData({});
        },
        isDisabled: orchestratorLoading || isSaving || isError
      }
    ]);
  }, [
    addFooterActions,
    isDirty,
    isError,
    isSaving,
    orchestratorLoading,
    saveAsync,
    mutateOrchestratorData
  ]);

  if (isLoading && !data) return <PaymentProgramSkeleton />;

  if (isError) {
    return (
      <div className="w-full p-6">
        <Typography size="small" color="danger-600">
          Couldn't load payment program settings
        </Typography>
      </div>
    );
  }

  return (
    <PaymentProgramBody
      draft={draft}
      dispatch={dispatch}
      activePhaseField={activePhaseField}
      setActivePhaseField={setActivePhaseField}
    />
  );
};

export default OnboardingPaymentProgram;
